'use client';
import React, { forwardRef } from 'react';

interface TypingInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}

/**
 * Invisible keystroke-capture layer (monkeytype-style). There is no visible box:
 * it sits transparently over the word display, stays focused, and feeds every
 * keystroke to the engine. Keeping a real <input> (rather than a window-level
 * key listener) means mobile keyboards still open on tap and IME/autocorrect off
 * behaves consistently.
 */
const TypingInput = forwardRef<HTMLInputElement, TypingInputProps>(
  ({ value, onChange, disabled, onFocus, onBlur }, ref) => {
    return (
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        autoFocus
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        tabIndex={-1}
        aria-label="Typing input — type the words shown above"
        className="typing-capture-input"
      />
    );
  }
);

TypingInput.displayName = 'TypingInput';
export default TypingInput;
